import callApi from './callApi';
export const getUserProjectList = async (
  perpage,
  page,
  search,
  includeTestCases,
  includeLinkedProjects
) => {
  const url = `projects?perpage=${perpage || 'all'}&page=${page || 1}&search=${search || ''
    }&includeTestCases=${includeTestCases || false}&includeLinkedProjects=${includeLinkedProjects || false}`;
  return await callApi(url, {}, 'GET');
};

export const getHeaderProjects = async () => {
  const url = `projects/header-projects`;
  return await callApi(url, {}, 'GET');
};

export const getDashboardProjects = async () => {
  const url = `projects/dashboard-projects`;
  return await callApi(url, {}, 'GET');
};

export const getFavouriteProjects = async () => {
  const url = `project-users/favourite-projects`;
  return await callApi(url, {}, 'GET');
};

export const getDashboardTestCaseData = async (projectIds) => {
  const url = `projects/dashboard-testcase-data`;
  return await callApi(url, {}, 'POST', { projectIds });
};

export const getDashboardAssignedTestCaseData = async (projectIds) => {
  const url = `projects/dashboard-assigned-testcase-data`;
  return await callApi(url, {}, 'POST', { projectIds });
};

export const getDashboardTestCaseReviewData = async (projectIds) => {
  const url = `projects/dashboard-testcase-review-data`;
  return await callApi(url, {}, 'POST', { projectIds });
};

export const approveTestCases = async (testcases) => {
  const url = `testcases/mark-approve`;
  return await callApi(url, {}, 'PUT', { testcases });
};

export const getDashboardTestCycleData = async (projectIds) => {
  const url = `projects/dashboard-testcycle-data`;
  return await callApi(url, {}, 'POST', { projectIds });
};

export const getDashboardIssueData = async (projectIds) => {
  const url = `projects/dashboard-issue-data`;
  return await callApi(url, {}, 'POST', { projectIds });
};

export const getAvailableProjectList = async () => {
  const url = `available-projects`;
  return callApi(url, {}, 'GET');
};

export const createUserProject = async (project) => {
  const url = `projects`;
  const headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    project,
  };
  return await callApi(url, headers, 'POST', body);
};

export const updateUserProject = async (project) => {
  let url = `projects/${project.id}`;
  let body = {
    project,
  };
  return await callApi(url, {}, 'PUT', body);
};

export const deleteUserProject = async (id) => {
  const url = `projects/${id}`;
  return await callApi(url, {}, 'DELETE');
};

export const createAvailableProject = async (project) => {
  const url = `available-projects`;
  const headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    project,
  };
  return await callApi(url, headers, 'POST', body);
};

export const updateAvailableProject = async (project, id) => {
  let url = `available-projects/${id}`;
  let body = {
    project,
  };
  return callApi(url, {}, 'PUT', body);
};

export const deleteAvailableProject = async (id) => {
  const url = `available-projects/${id}`;
  return callApi(url, {}, 'DELETE');
};

export const listAvailableProjectById = async (id) => {
  const url = `available-projects?id=${id}`;
  return callApi(url, {}, 'GET');
};

//----------skills------------------>
export const getSkillsList = async () => {
  const url = `skills`;
  return callApi(url, {}, 'GET');
};

//----------task list---------------->

export const getTaskList = async () => {
  const url = `tasks`;
  return callApi(url, {}, 'GET');
};

//-------assign user to project------>
export const assignUserToProject = async (users) => {
  const url = `project-users`;
  const headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    users,
  };
  return callApi(url, headers, 'POST', body);
};

export const editUserRoleInProject = async (user) => {
  const url = `project-users/${user.user_id}`;
  const headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    user,
  };
  return callApi(url, headers, 'PUT', body);
};

export const getSingleAvailableProject = async (id) => {
  const url = `available-projects/project/${id}`;
  return callApi(url, {}, 'GET');
};

export const getUserAssociatedProjects = async (id) => {
  const url = `project-users?project`;
  return callApi(url, {}, 'GET');
};

export const getCurrentUserAssociation = async (projectId) => {
  const url = `project-users/current?projectId=${projectId}`;
  return callApi(url, {}, 'GET');
};

export const getAssociatedUsers = async (id, searchValue = '') => {
  const url = `project-users?projectId=${id}&search=${searchValue || ''}`;
  return callApi(url, {}, 'GET');
};

export const removeAssociatedUsers = async (id) => {
  const url = `project-users/${id}`;
  return callApi(url, {}, 'DELETE');
};

export const getCurrentProject = async (id) => {
  const url = `projects/${id}`;
  return callApi(url, {}, 'GET');
};

export const getAssignedProjects = async () => {
  const url = `project-users/assigned-projects`;
  return await callApi(url, {}, 'GET');
};

export const createExportRequest = async (exportOptions) => {
  const url = `projects/create-export-request`;
  return await callApi(url, {}, 'POST', exportOptions);
};

export const getLinkedJiraProjects = async (projectId) => {
  const url = `projects/linked-jira-projects/${projectId}`;
  return callApi(url, {}, 'GET');
};

export const saveJiraProjects = async (body, projectId) => {
  const url = `projects/save-project?projectId=${projectId}`;
  return callApi(url, {}, 'POST', body);
};

export const markProjectAsFavourite = async (projectId, favourite) => {
  const url = `project-users/favourite/${projectId}`;
  const body = {
    favourite,
  };
  return await callApi(url, {}, 'POST', body);
};

export const fetchProjectHistory = async (projectId) => {
  const url = `projects/${projectId}/history`;
  return await callApi(url, {}, 'GET');
}